import React, {
  MouseEvent,
} from 'react';
import clsx from 'clsx';
import {
  useCallForAppointmentReminder,
} from 'pages/Dashboard/pages/Appointments/pages/List/hooks';
import Spinner from 'pages/Dashboard/components/Spinner';
import {
  useNotify,
} from 'core/hooks';
import {
  Button,
} from 'pages/Dashboard/components/Button';

type Props = {
  encounterId: number;
};

export default function CallAIButton({ encounterId }: Props) {
  const notify = useNotify();

  const {
    mutateAsync: callAI,
    isPending: isLoading,
  } = useCallForAppointmentReminder();

  const onClick = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    await callAI({ encounterId });
    notify({
      variant: 'success',
      message: 'Appointment confirmation initiated via AI voice agent.',
    });
  };

  return (
    <Button
      className={clsx(
        '!py-0.5 !min-w-[120px]',
        { '!border-blue-500': !isLoading },
      )}
      variant="outlined"
      type="submit"
      color="primary"
      onClick={onClick}
      disabled={isLoading}
      size="small"
    >
      {isLoading
        ? (
          <div className="gap-2 flex items-center">
            <Spinner size={16} />
            Calling...
          </div>
        ) : 'Call'}
    </Button>
  );
}
